import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IChannelDimensionsLimitsResponseModel, IChannelDimensionsDataModel, IRegionalEcosystemStatusesResponseModel } from '../models/veg-wizard-models';

@Injectable({
  providedIn: 'root'
})
export class ChannelDimensionsService {
  constructor(
    protected http: HttpClient) {
  }

  setChannelDimensions$(model: IChannelDimensionsDataModel): Observable<IRegionalEcosystemStatusesResponseModel> {
    
    const url = `${environment.apiUrl}/session/set-channel-dimensions`;    
    return this.http.post<IRegionalEcosystemStatusesResponseModel>(url, model);    
  }

  getChannelDimensions$(sessionId: string): Observable<IChannelDimensionsLimitsResponseModel> {  

    const url = `${environment.apiUrl}/session/channel-dimension-limits-for-category-purpose-activity?sessionKey=${sessionId}`;
    return this.http.get<IChannelDimensionsLimitsResponseModel>(url);
  }
}
